import React, { useEffect, useState } from "react";
import {
  Card,
  CardContent,
  Typography,
  Box,
  Paper,
  Switch,
} from "@mui/material";
import WbTwilight from "@mui/icons-material/WbTwilightOutlined";
import FavoriteBorder from "@mui/icons-material/FavoriteBorder";
import Close from "@mui/icons-material/Close";
import Check from "@mui/icons-material/Check";
import apiService from "../../../service/Api"; // ✅ API service
import {
  showErrorToast,
  showSuccessToast,
} from "../../../components/common/ShowToast";


interface ObituaryResponse {
  orbituary: string;
}

const ToggleRow = ({
  title,
  icon,
  checked,
  onToggle,
  reduxTheme,
}: {
  title: string;
  icon: React.ReactNode;
  checked: boolean;
  onToggle: () => void;
  reduxTheme: any;
}) => (
  <Paper sx={{ flex: 1, p: 2, minHeight: 71, borderRadius: 4 }}>
    <Box display="flex" alignItems="center" justifyContent="space-between">
      <Box display="flex" alignItems="center" gap={1}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: 42,
            height: 42,
            borderRadius: "50%",
            backgroundColor: reduxTheme.primary_colors?.[800],
          }}
        >
          {icon}
        </Box>
        <Typography variant="h6">{title}</Typography>
      </Box>
      <Switch checked={checked} onChange={onToggle} />
    </Box>
  </Paper>
);




const ObituaryPanel = ({
  reduxTheme,
  deceasedId,
  featuresEnabled,
  toggleFeature,
}: {
  reduxTheme: any;
  deceasedId: number | null;
  featuresEnabled: Record<string, boolean>;
  toggleFeature: (id: string) => void;
}) => {
  const [obituaryText, setObituaryText] = useState<string>("");
  const [editing, setEditing] = useState(false);
  const [backupText, setBackupText] = useState<string>("");

  const [websiteId, setWebsiteId] = useState<number | null>(null);
  const [features, setFeatures] = useState({
    sunrise: false,
    sunset: false,
    age: false,
    orbituary: false,
  });

  useEffect(() => {
    const fetchObituary = async () => {
      if (!deceasedId) return;

      try {
        const response = await apiService.get<{
          deceased: { orbituary: string };
        }>(`api/client-portal/deceased/view/${deceasedId}/`);

        setObituaryText(
          response.data.deceased.orbituary || "No obituary available yet."
        );
      } catch (err) {
        console.error("Failed to fetch obituary data", err);
        setObituaryText("Failed to load obituary.");
      }
    };

    fetchObituary();
  }, [deceasedId]);


    const fetchWebsite = async () => {
      if (!deceasedId) return;
      try {
        const res = await apiService.get(
          `/api/client-portal/websites/?deceased=${deceasedId}`
        );

        const dataResponse = res.data;
        let data: any = null;

        if (Array.isArray(dataResponse) && dataResponse.length > 0) {
          data = dataResponse[0];
        } else if (
          typeof dataResponse === "object" &&
          dataResponse !== null &&
          "results" in dataResponse &&
          Array.isArray((dataResponse as any).results) &&
          (dataResponse as any).results.length > 0
        ) {
          data = (dataResponse as any).results[0];
        } else if (
          typeof dataResponse === "object" &&
          dataResponse !== null &&
          "id" in dataResponse
        ) {
          data = dataResponse;
        }

        console.log(data);

        if (data?.id) {
          setWebsiteId(data.id);
          setFeatures({
            sunrise: data.show_sunrise,
            sunset: data.show_sunset,
            age: data.show_age,
            orbituary: data.show_orbituary,
          });
        }
      } catch (err) {
        console.error("Failed to fetch website info", err);
      }
    };
     useEffect(() => {
    fetchWebsite();
  }, [deceasedId]);

  const handleToggleFeature = async (
    feature:
      | "orbituary"
      | "sunset"
      | "sunrise"
      | "age"
     
  ) => {
    if (!websiteId) return;
    const newValue = !features[feature];
    try {
      console.log({ newValue });
      await apiService.patch(`/api/client-portal/websites/${websiteId}/`, {
        [`show_${feature}`]: newValue,
      });
      setFeatures((prev) => ({ ...prev, [feature]: newValue }));
      showSuccessToast?.(`Updated ${feature} successfully.`);
    } catch (err) {
      console.error(`Failed to update ${feature}`, err);
      showErrorToast?.(`Failed to update ${feature}.`);
    }
  };

  const handleToggle = (id: string) => {
    toggleFeature(id);
    if (id === "orbituary") handleToggleFeature("orbituary");
    if (id === "age") handleToggleFeature("age");
    if (id === "sunset") handleToggleFeature("sunset");
    if (id === "sunrise") handleToggleFeature("sunrise");
   
  };


  

  return (
    <Card
      sx={{
        height: 482,
        backgroundColor: reduxTheme.primary_colors?.[800],
        borderRadius: 3,
        pt: 10,
        width: 660,
      }}
    >
      <CardContent>
        <Box
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          sx={{ width: "100%" }}
        >
          <Typography variant="h6" sx={{ fontWeight: "bold", mt: -12 }}>
            Choose orbituary to display
          </Typography>

          <Box display="flex" alignItems="center" gap={1}>
            <Typography variant="h6" sx={{ fontWeight: "bold", mt: -12 }}>
              Enable/Disable
            </Typography>
            <Switch size="small" sx={{ mt: -12 }} defaultChecked />
          </Box>
        </Box>

        <Box display="flex" gap={2} alignItems="flex-start">
          <Paper sx={{ flex: 1, p: 2, height: 350, mb: 2, borderRadius: 4 }}>
            <Typography
              variant="body2"
              sx={{
                color: "text.secondary",
                opacity: 0.7,
                mt: 2,
              }}
            >
              Edit Orbituary
            </Typography>

            <Box
              sx={{
                height: 250,
                overflowY: "auto",
                paddingRight: 1,
              }}
            >
              {editing ? (
                <textarea
                  style={{
                    width: "100%",
                    height: "100%",
                    border: "none",
                    outline: "none",
                    background: "transparent",
                    color: "inherit",
                    resize: "none",
                  }}
                  value={obituaryText}
                  onChange={(e) => setObituaryText(e.target.value)}
                />
              ) : (
                <div
                  onClick={() => {
                    const stripHtml = (
                      html: string | null | undefined
                    ): string => (html ? html.replace(/<[^>]+>/g, "") : "");

                    setBackupText(obituaryText);
                    setObituaryText(stripHtml(obituaryText)); // REMOVE HTML BEFORE EDITING
                    setEditing(true);
                  }}
                  dangerouslySetInnerHTML={{
                    __html:
                      obituaryText?.trim() || "<p>No obituary available.</p>",
                  }}
                  style={{ cursor: "text" }}
                />
              )}
            </Box>

            <Box display="flex" alignItems="center" gap={1} mt={1}>
              {/* Cancel Button */}
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: 22,
                  height: 22,
                  borderRadius: "50%",
                  border: "1px solid red",
                  cursor: "pointer",
                }}
                onClick={() => {
                  setObituaryText(backupText);
                  setEditing(false);
                }}
              >
                <Close sx={{ color: "red", fontSize: 18 }} />
              </Box>

              {/* Save Button */}
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: 22,
                  height: 22,
                  borderRadius: "50%",
                  border: "1px solid green",
                  cursor: "pointer",
                }}
                onClick={async () => {
                  if (!deceasedId) return;
                  try {
                    const res = await apiService.patch<ObituaryResponse>(
                      `api/client-portal/deceased/view/${deceasedId}/`,
                      {
                        orbituary: obituaryText,
                      }
                    );

                    setObituaryText(res.data.orbituary);
                    setEditing(false);
                  } catch (err) {
                    console.error("Failed to save obituary", err);
                  }
                }}
              >
                <Check sx={{ color: "green", fontSize: 18 }} />
              </Box>
            </Box>
          </Paper>

          <Box display="flex" flexDirection="column" gap={2} flex={1}>
            <ToggleRow
              icon={
                <WbTwilight
                  sx={{ color: reduxTheme.primary_colors?.[400], fontSize: 14 }}
                />
              }
              title="Sunrise"
              checked={features["sunrise"]}
              onToggle={() => handleToggleFeature("sunrise")}
              reduxTheme={reduxTheme}
            />
            <ToggleRow
              title="Sunset"
              icon={
                <WbTwilight
                  sx={{ color: reduxTheme.primary_colors?.[400], fontSize: 14 }}
                />
              }
              checked={features["sunset"]}
              onToggle={() => handleToggleFeature("sunset")}
              reduxTheme={reduxTheme}
            />
            <ToggleRow
              title="Age"
              icon={
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: 20,
                    height: 20,
                    borderRadius: "50%",
                    border: `1px solid ${reduxTheme.primary_colors?.[400]}`,
                  }}
                >
                  <FavoriteBorder
                    sx={{
                      color: reduxTheme.primary_colors?.[400],
                      fontSize: 14,
                    }}
                  />
                </Box>
              }
              checked={features["age"]}
              onToggle={() => handleToggleFeature("age")}
              reduxTheme={reduxTheme}
            />
            <ToggleRow
              title="Obituary"
              icon={
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: 20,
                    height: 20,
                    borderRadius: "50%",
                    border: `1px solid ${reduxTheme.primary_colors?.[400]}`,
                  }}
                >
                  <FavoriteBorder
                    sx={{
                      color: reduxTheme.primary_colors?.[400],
                      fontSize: 14,
                    }}
                  />
                </Box>
              }
              checked={features["orbituary"]}
              onToggle={() => handleToggleFeature("orbituary")}
              reduxTheme={reduxTheme}
            />
          </Box>
        </Box>
      </CardContent>
    </Card>
  );
};

export default ObituaryPanel;
